import React from 'react';
import PropTypes from 'prop-types';

const NewsletterConfirmationItem = ({
  siteName,
  topHeader,
  deliveryDays,
}) => {
  return (
    <div className="add-on-item">
      <div className="add-on-item__newsletter-name">
        {topHeader}
      </div>
      <div className="add-on-item__site-name">
        {siteName}
      </div>
      <div className="add-on-item__newsletter-delivery">
        Publishes {deliveryDays}
      </div>
    </div>
  );
};

NewsletterConfirmationItem.propTypes = {
  siteName: PropTypes.string.isRequired,
  topHeader: PropTypes.string.isRequired,
  deliveryDays: PropTypes.string.isRequired,
};

export default NewsletterConfirmationItem;
